import { render, staticRenderFns } from "./Myfriends.vue?vue&type=template&id=2bbe20f8&"
import script from "./Myfriends.vue?vue&type=script&lang=js&"
export * from "./Myfriends.vue?vue&type=script&lang=js&"
import style0 from "./Myfriends.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports